export default {
  threadsList: '/threads/',
  contributionsList: '/threads/my-contributions/',
  allThreadsList: '/threads/all-threads/',
  ganttList: 'threads/gantt-data/',
  contributionsGanttList: 'threads/gantt-data/?type=my_contribution',
  allThreadsGanttList: 'threads/gantt-data/?type=all_threads',
};
